import { TicketsPage } from '@pages/Admin/ErrorTickets/pages/TicketsPage';

export const DevCriticalTickets = () => {
  return <TicketsPage ticketType={3} />;
};
